/* eslint-disable @typescript-eslint/consistent-type-definitions */
var MobileAppMessageTypes;
(function (MobileAppMessageTypes) {
    MobileAppMessageTypes["NAVIGATE_TO_FROM_WEBVIEW"] = "NAVIGATE_TO_FROM_WEBVIEW";
    MobileAppMessageTypes["NAVIGATE_TO_FROM_MOBILE_APP"] = "NAVIGATE_TO_FROM_MOBILE_APP";
    MobileAppMessageTypes["SESSION_CREATED"] = "SESSION_CREATED";
    MobileAppMessageTypes["SESSION_UPDATED"] = "SESSION_UPDATED";
    MobileAppMessageTypes["SESSION_DESTROYED"] = "SESSION_DESTROYED";
    MobileAppMessageTypes["WEBVIEW_LIFECYCLE"] = "WEBVIEW_LIFECYCLE";
    MobileAppMessageTypes["BIOMETRIC_REQUEST"] = "BIOMETRIC_REQUEST";
    MobileAppMessageTypes["BIOMETRIC_RESPONSE"] = "BIOMETRIC_RESPONSE";
    MobileAppMessageTypes["CURRENCY_CHANGED"] = "CURRENCY_CHANGED";
    MobileAppMessageTypes["CURRENCY_CHANGED_REQUEST"] = "CURRENCY_CHANGED_REQUEST";
    MobileAppMessageTypes["TRACKING_ENABLED_REQUEST"] = "TRACKING_ENABLED_REQUEST";
    MobileAppMessageTypes["TRACKING_ENABLED_RESPONSE"] = "TRACKING_ENABLED_RESPONSE";
    MobileAppMessageTypes["SESSION_STATUS_REQUEST"] = "SESSION_STATUS_REQUEST";
    MobileAppMessageTypes["SESSION_STATUS_RESPONSE"] = "SESSION_STATUS_RESPONSE";
    MobileAppMessageTypes["LOGIN_REQUEST"] = "LOGIN_REQUEST";
    MobileAppMessageTypes["LOGIN_RESPONSE"] = "LOGIN_RESPONSE";
    MobileAppMessageTypes["LOGOUT_REQUEST"] = "LOGOUT_REQUEST";
    MobileAppMessageTypes["SOCKET_EVENT"] = "SOCKET_EVENT";
    MobileAppMessageTypes["MESSAGE_MARK_AS_READ"] = "MESSAGE_MARK_AS_READ";
})(MobileAppMessageTypes || (MobileAppMessageTypes = {}));
var MobileAppNativeRoutes;
(function (MobileAppNativeRoutes) {
    MobileAppNativeRoutes["SETTINGS_SCREEN"] = "settings";
    MobileAppNativeRoutes["SIGN_UP_SCREEN"] = "registration";
})(MobileAppNativeRoutes || (MobileAppNativeRoutes = {}));
var MobileAppSessionStatus;
(function (MobileAppSessionStatus) {
    // Session status not checked yet
    MobileAppSessionStatus["UNKNOWN"] = "Unknown";
    // User is logged in
    MobileAppSessionStatus["LOGGED_IN"] = "LoggedIn";
    // User explicitly logged out
    MobileAppSessionStatus["LOGGED_OUT"] = "LoggedOut";
    // Session explicitly terminated by a third party
    MobileAppSessionStatus["TERMINATED"] = "Terminated";
    // Session expired while active
    MobileAppSessionStatus["EXPIRED"] = "Expired";
    // No session at all after checking
    MobileAppSessionStatus["NO_SESSION"] = "NoSession";
})(MobileAppSessionStatus || (MobileAppSessionStatus = {}));

export { MobileAppMessageTypes, MobileAppNativeRoutes, MobileAppSessionStatus };
